export const ACCESS_FEATURE = {
  TEMPLATE_ONLY: 'template_only',
} as const;
